import { themeVariables } from '@noths/polaris-design-system-abstract-theme';
import { css } from 'styled-components';

export const root = css`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  color: var(${themeVariables.colors.content.primary});
`;

export const preSaleInfo = css`
  display: flex;
  align-items: baseline;
  gap: var(${themeVariables.spacing.xs});
  font-family: var(${themeVariables.typography.body.fontFamily});
  font-size: var(${themeVariables.typography.body.sizes.sm.fontSize});
  line-height: var(${themeVariables.typography.body.sizes.sm.lineHeight});
`;

export const from = css`
  display: block;
  font-family: var(${themeVariables.typography.body.fontFamily});
  font-size: var(${themeVariables.typography.body.sizes.sm.fontSize});
  line-height: var(${themeVariables.typography.body.sizes.sm.lineHeight});
`;

export const currentPrice = css`
  display: inline-block;
  margin: 0;
  color: var(${themeVariables.colors.content.primary});
  font-family: var(${themeVariables.typography.heading.fontFamily});
  font-size: var(${themeVariables.typography.heading.sizes.xs.fontSize});
  line-height: var(${themeVariables.typography.heading.sizes.xs.lineHeight});
`;

export const previousPrice = css`
  display: inline-block;
  margin: 0;
  color: var(${themeVariables.colors.content.secondary});
  font-family: var(${themeVariables.typography.body.fontFamily});
  font-size: var(${themeVariables.typography.body.sizes.sm.fontSize});
  line-height: var(${themeVariables.typography.body.sizes.sm.lineHeight});
`;

export const percentageOff = css`
  display: inline-block;
  white-space: nowrap;
  color: var(${themeVariables.colors.content.positive});
  font-family: var(${themeVariables.typography.body.fontFamily});
  font-size: var(${themeVariables.typography.body.sizes.sm.fontSize});
  line-height: var(${themeVariables.typography.body.sizes.sm.lineHeight});
`;

export const percentageOffRed = css`
  color: var(${themeVariables.colors.content.negative});
`;
